import React from "react"
import { useLocation } from "react-router-dom"
import WaitlistLayout from "../components/Common/WaitlistLayout"
import WaitlistForm from "../components/WaitlistForm/WaitlistForm"

const WaitlistPage = () => {
  const location = useLocation()
  const title = location?.state?.title || "Learn More"
  const footerText = location?.state?.footerText || "#1 Integration Solution For Camps."

  return (
    <WaitlistLayout>
      <WaitlistForm withLogo={true} title={title} footerText={footerText} />
    </WaitlistLayout>
  )
}

export default WaitlistPage
